import { BaseSlugData } from '@openticket/lib-sdk-helpers';
import { errorToSlugData } from '@/composables/deferred/deferred.errors';

// ----
// Deferred States
// ----

export interface StatePolling {
    // polledIndex < pollLimit
    state: 'polling';
    fetchError: null;
    fetchErrorSlug?: BaseSlugData;
    showFetchStatusButton: false;
    orderResult: null;
}

export interface StatePollingTimeout {
    // without order result
    // polledIndex < pollLimit
    state: 'timeout';
    fetchError: 'timeout';
    fetchErrorSlug?: BaseSlugData;
    showFetchStatusButton: true;
    orderResult: null;
}

export interface StatePollingFailed {
    // status call throws or body not valid order response.
    state: 'failed';
    fetchError: 'failed' | 'unexpected';
    fetchErrorSlug?: BaseSlugData;
    showFetchStatusButton: boolean; // !polling
    orderResult: null;
}

export interface StateOrderResultInvalid {
    // Status >= 400; End-of-line.
    // Unknown if error from nautilus or ShopApi.
    // Error from nautilus at this stage is irrelevant.

    // polledIndex < pollLimit
    state: 'invalid';
    fetchError: 'invalid';
    fetchErrorSlug?: BaseSlugData;
    showFetchStatusButton: false;
    orderResult: OrderResultInvalidWithoutCart | OrderResultInvalidWithCart;
}

export interface StateOrderReceived {
    // HAPPY PATH
    // polledIndex < pollLimit
    state: 'ok';
    fetchError: null;
    fetchErrorSlug?: BaseSlugData;
    showFetchStatusButton: false;
    orderResult: OrderResultValid;
}

export type States =
    | StatePolling
    | StatePollingTimeout
    | StatePollingFailed
    | StateOrderResultInvalid
    | StateOrderReceived;

export const pollingState: StatePolling = {
    state: 'polling',
    fetchError: null,
    showFetchStatusButton: false,
    orderResult: null,
};

export const timeoutState: StatePollingTimeout = {
    state: 'timeout',
    fetchError: 'timeout',
    fetchErrorSlug: errorToSlugData('timeout'),
    showFetchStatusButton: true,
    orderResult: null,
};

// ----
// Order Results
// ----

export interface OrderResultInvalidWithoutCart {
    valid: false;
    error: string;
    delayMs: number;
    toShop: 'reset';
    redirectUrl: null;
}

export interface OrderResultInvalidWithCart {
    valid: false;
    error: string;
    delayMs: number;
    toShop: 'back';
    redirectUrl: null;
}

export interface OrderResultValid {
    valid: true;
    error: null;
    delayMs: number;
    toShop: null;
    redirectUrl: string;
}
